(() => {
  if (window.cmExperienceReady) return;
  window.cmExperienceReady = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let opener;
  let queued = false;

  function updateChapters() {
    queued = false;
    if (document.hidden) return;
    const hero = document.querySelector('[data-experience-hero]');
    if (hero && !motion.matches) {
      const rect = hero.getBoundingClientRect();
      const travel = motion.matches ? 0 : Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      if (rect.bottom > 0 && rect.top < window.innerHeight) hero.style.setProperty('--hero-travel', travel.toFixed(3));
    }
    document.querySelectorAll('[data-journey]').forEach(journey => {
      const chapters = [...journey.querySelectorAll('[data-journey-chapter]')];
      const focusLine = window.innerHeight * 0.55;
      let active = chapters[0];
      chapters.forEach(chapter => {
        if (chapter.getBoundingClientRect().top <= focusLine) active = chapter;
      });
      if (!active) return;
      const index = active.dataset.journeyChapter;
      journey.dataset.chapter = index;
      journey.querySelectorAll('.cm-journey-progress a').forEach((link, i) => {
        if (String(i) === index) link.setAttribute('aria-current', 'step');
        else link.removeAttribute('aria-current');
      });
    });
  }
  function schedule() {
    if (document.hidden || !document.querySelector('[data-experience-hero],[data-journey]')) return;
    if (!queued) {
      queued = true;
      window.requestAnimationFrame(updateChapters);
    }
  }
  function init() {
    document.documentElement.classList.add('cm-experience-ready');
    document.querySelectorAll('[data-intent-finder]').forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cm-finder-open');
        if (opener?.isConnected) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
    schedule();
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-open-finder]');
    const dialog = document.querySelector('[data-intent-finder]');
    if (open && dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      opener = open;
      dialog.showModal();
      document.documentElement.classList.add('cm-finder-open');
      dialog.querySelector('[aria-pressed="true"]')?.focus({preventScroll: true});
      return;
    }
    if (!dialog || !dialog.contains(event.target)) return;
    if (event.target.closest('[data-close-finder]')) dialog.close();
    const choice = event.target.closest('[data-finder-choice]');
    if (!choice) return;
    const panel = [...dialog.querySelectorAll('[data-finder-result]')].find(item => item.dataset.finderResult === choice.dataset.finderChoice);
    if (!panel) return;
    dialog.querySelectorAll('[data-finder-choice]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
    dialog.querySelectorAll('[data-finder-result]').forEach(result => { result.hidden = result !== panel; });
    dialog.querySelector('.cm-finder-live').textContent = panel.querySelector('h3').textContent;
  });
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('pageshow', schedule);
  motion.addEventListener('change', () => {
    if (motion.matches) document.querySelector('[data-experience-hero]')?.style.removeProperty('--hero-travel');
    schedule();
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
